import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Car, Loader2 } from "lucide-react";

export default function DriverLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/driver/login", { email, password });
      localStorage.setItem("apex_driver_token", data.token);
      localStorage.setItem("apex_driver", JSON.stringify(data.driver));
      toast.success(`Kia ora ${data.driver.name}`);
      nav("/driver");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#090D14] grid place-items-center text-white p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-10 justify-center">
          <div className="w-11 h-11 rounded-lg bg-gradient-to-br from-amber-400 to-amber-600 grid place-items-center text-[#090D14] font-black text-xl font-display">A</div>
          <div><div className="font-display font-extrabold text-white text-xl">Apex Drivers</div><div className="text-[10px] uppercase tracking-[0.25em] text-amber-400/80 font-mono">Fleet Portal</div></div>
        </Link>
        <form onSubmit={submit} className="glass-card rounded-2xl p-8 gold-border">
          <div className="text-caption mb-2 flex items-center gap-1.5"><Car className="w-3.5 h-3.5" /> Driver Sign-in</div>
          <h1 className="font-display text-2xl font-bold">Ready to roll?</h1>
          <div className="mt-6 space-y-4">
            <div><Label className="text-xs uppercase text-slate-400">Email</Label><Input data-testid="driver-login-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="bg-black/30 border-white/10 h-11 mt-2" /></div>
            <div><Label className="text-xs uppercase text-slate-400">Password</Label><Input data-testid="driver-login-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="bg-black/30 border-white/10 h-11 mt-2" /></div>
            <Button data-testid="driver-login-submit" type="submit" disabled={loading} className="w-full btn-gold rounded-lg h-11">{loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Sign in</Button>
            <div className="text-center text-sm text-slate-400 pt-2 border-t border-white/5 mt-4">
              New driver? <Link to="/driver/apply" className="text-amber-400 hover:text-amber-300" data-testid="driver-apply-link">Apply to drive with Triptap →</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
